{{#if showBulkActions}}
	{{#each bulkActions}}
		<button
		  type="button"
		  class="btn btn-secondary btn-xs{{#if ../bulkActionsDisabled}} disabled{{/if}}"
		  {{#if ../bulkActionsDisabled}} disabled{{/if}}
		  data-qa="{{qa}}"
		  data-index="{{@index}}"
    >{{label}}</button>
	{{/each}}
{{/if}}
